import { Tooltip } from "antd";

const ProcessBar = ({ data }) => {
  // Clean up numbers by removing commas and converting to Number
  const parsedData = data?.map((item) => ({
    ...item,
    count: Number(String(item?.count || "0").replace(/,/g, "")),
  }));

  const total = parsedData?.reduce((sum, item) => sum + item?.count, 0);

  return (
    <div className="w-full">
      {/* Bar */}
      <div className="flex w-full h-[13px] rounded-full overflow-hidden shadow-inner bg-gray-200">
        {parsedData?.map((item, index) => {
          const widthPercent = total === 0 ? 0 : (item?.count / total) * 100;
          return (
            <Tooltip
              key={index}
              title={`${item?.name}: ${item?.count} (${widthPercent?.toFixed(
                0
              )}%)`}
            >
              <div
                className="h-full transition-all duration-300 cursor-pointer"
                style={{
                  width: `${widthPercent}%`,
                  backgroundColor: item?.color,
                }}
              />
            </Tooltip>
          );
        })}
      </div>

      {/* Text below */}
      <div className="flex justify-between mt-1 text-xs">
        <span className="text-gray-600">
          {total > 0
            ? `${((parsedData[0].count / total) * 100).toFixed(0)}% Completed`
            : "0% Completed"}
        </span>
        <span className="text-gray-600">
          {total > 0
            ? `${((parsedData[1].count / total) * 100).toFixed(0)}% Pending`
            : "0% Pending"}
        </span>
      </div>
    </div>
  );
};

export default ProcessBar;
